var _desc, _defs, _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M6.875 0L15.125 0C18.9214 0 22 3.07861 22 6.875L22 15.125C22 18.9214 18.9214 22 15.125 22L6.875 22C3.07861 22 0 18.9214 0 15.125L0 6.875C0 3.07861 3.07861 0 6.875 0ZM15.125 19.9375C17.7788 19.9375 19.9375 17.7788 19.9375 15.125L19.9375 6.875C19.9375 4.22119 17.7788 2.0625 15.125 2.0625L6.875 2.0625C4.22119 2.0625 2.0625 4.22119 2.0625 6.875L2.0625 15.125C2.0625 17.7788 4.22119 19.9375 6.875 19.9375L15.125 19.9375Z",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.5 11C5.5 7.9624 7.96265 5.5 11 5.5C14.0374 5.5 16.5 7.9624 16.5 11C16.5 14.0376 14.0374 16.5 11 16.5C7.96265 16.5 5.5 14.0376 5.5 11ZM7.5625 11C7.5625 12.8945 9.10522 14.4375 11 14.4375C12.8948 14.4375 14.4375 12.8945 14.4375 11C14.4375 9.104 12.8948 7.5625 11 7.5625C9.10522 7.5625 7.5625 9.104 7.5625 11Z",
    clipRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 16.912598,
    cy: 5.087402,
    r: 0.732875,
    fill: "#FFFFFF",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.dd92f968117313b8d27ea4b98f46551d.svg";
export { ForwardRef as ReactComponent };